import DemandPlanningPage from 'pages/demandplanning'
import React from 'react'

export default function DemandPlanningView() {
  return <DemandPlanningPage />
}
